/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import moment from "moment";
import { APIEndpoint, DFPAPIEndpoint } from '../../../../utils/axios';
import { EditModal } from '../../../../common';
import { updateButtonTxtStatus, formatDateByTimezone, calculateTextWidth, getEndDateMaxLimit} from "../../../../utils/commonFunctions";
import  LoadingIn from '../../../../assets/loadingIn.gif';
import checkDownloadStatus from '../../../../utils/checkDownloadStatus';
import { toast } from 'react-toastify';

export const SalesReportsDownloadComponent = (props) => {

    const { t } = useTranslation();
    const [ modalTitle ] = useState('Download Reports');
    const [modalCustomButtons, setModalCustomButtons] = useState(null);
    const modelStyle = { maxWidth: '80%' };
    const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
    const [, setUpdatedFormFieldValues] = useState({});
    const [modalFormData, setModalFormData] = useState({});

    const [reportTypes, setReportTypes] = useState([]);
    const [reptType,setReptType]=useState(null);
    const [routes, setRoutes] = useState([]);
    const [editFormFields, setEditFormFields] = useState([]);
    const [cateringGroups, setCateringGroups] = useState([]);
    const [isCateringGroupsLoading, setIsCateringGroupsLoading] = useState(false);
    const isLoadingCateringGroupsRef = useRef(false);
    const [cateringGroupWidth, setCateringGroupWidth] = useState('17rem');

    const allFormInputs = [
      { key: 'reportType', label: 'Report Type', name: 'reportType', id: 'reportType', attribute: 'reportType', type: 'select', disabled:false,
          required: true, className: 'select-search-cls'
          , options: reportTypes

      },
      { key: 'filterByTransactionDate', label: 'Filter by Transaction Date', name: 'filterByTransactionDate', id: 'filterByTransactionDate', attribute: 'filterByTransactionDate', type: 'checkbox',
          required: false, disabled: false,
      },
      { key: 'startDate', label: 'Start Date', name: 'startDate', id: 'startDate', attribute: 'startDate', type: 'date', required: true, disabled: false,
          placeholder: t('datePickerPlaceholder'),
          className: 'date-input',
      },
      { key: 'endDate', label: 'End Date', name: 'endDate', id: 'endDate', attribute: 'endDate', type: 'date', required: true, disabled: false,
          placeholder: t('datePickerPlaceholder'),
          className: 'date-input',
          maxDate: modalFormData.startDate ? getEndDateMaxLimit(modalFormData.startDate) : null
      },
      { key: 'transDate', label: 'Date', name: 'transDate', id: 'transDate', attribute: 'transDate', type: 'date', required: true, disabled: false,
              placeholder: t('datePickerPlaceholder'),
              className: 'date-input',maxDate:new Date()
      },
      { key: 'selectRoute', label: 'Select Route', name: 'selectRoute', id: 'selectRoute', attribute: 'selectRoute', type: 'selectSearch2', disabled: false,
          required: false, className: 'select-search-cls',
          options: routes

      },
      { key: 'cateringGroup', label: 'Catering Group', name: 'cateringGroup', id: 'cateringGroup', attribute: 'cateringGroup', type: 'selectSearch2', disabled: false,
          required: true, className: 'select-search-cls',
          options: cateringGroups,
          optionsLoading: isCateringGroupsLoading
      },
  ];
  const [allFormInputsFin, setAllFormInputsFin] = useState(allFormInputs);

    useEffect( () => {

        loadReportTypes();

        if ( props.sectorList.length > 0) {
            popupForm_loadRoutes();
        }


        setUpInitialFormFields();


        setModalCustomButtons([
            { label: 'Download', attribute: 'button', type: 'button', disabled: false, className: 'submit-button-rep1 mt-4'
                , action: 'onSubmit'
                , style: {} // Will be updated dynamically
            }
        ]);

    }, []);

    useEffect(() => {
      const modFormInputs = allFormInputs.map((formFields) => {
        if (formFields.attribute === 'reportType' && (modalFormData.reportType || reptType)) {
          const updates = {
           ...formFields,
            value: reptType || modalFormData.reportType || null,
            options: reportTypes,
          };
          // Apply dynamic width to reportType for stockMovementVarianceReport
          // For 'select' type, we need to use style object instead of width property
          if (modalFormData.reportType === 'stockMovementVarianceReport' || reptType === 'stockMovementVarianceReport') {
            updates.style = { width: cateringGroupWidth };
          }
          return updates;
        }
        if (formFields.attribute === 'cateringGroup') {
          return {
           ...formFields,
            options: cateringGroups,
            optionsLoading: isCateringGroupsLoading,
            width: cateringGroupWidth
          };
        }
        // Apply dynamic width to transDate for stockMovementVarianceReport
        if (formFields.attribute === 'transDate' && (modalFormData.reportType === 'stockMovementVarianceReport' || reptType === 'stockMovementVarianceReport')) {
          return {
           ...formFields,
            width: cateringGroupWidth
          };
        }
  
        if (formFields.attribute === 'endDate') {
          return {
           ...formFields,
            maxDate: modalFormData.startDate ? getEndDateMaxLimit(modalFormData.startDate) : null
          };
        }
        return formFields;
      });

      setAllFormInputsFin(modFormInputs);
    }, [modalFormData.reportType, modalFormData.startDate, reptType, reportTypes, cateringGroups, isCateringGroupsLoading, cateringGroupWidth]);


    useEffect( () => {
        showFieldValidation();

    }, [ editFormFields ]);
    useEffect(() => {
      if(props.reportSel){
        let repSelected=reportTypes.find(rpt=>rpt.label===props.reportSel)
        if(repSelected){
          setReptType(repSelected.value)
          setEditFormFields(editFormFields.filter( (field) => {
            if (field.attribute === 'reportType') {
                field.disabled = true;
                field.options=reportTypes;
                field.value=repSelected.value
            }
            if (field.attribute === 'selectRoute') {
              field.disabled = true;
              field.options=routes;
          }
            return field;
        }) );
        }
      }

    }, [props,reportTypes,allFormInputsFin])


useEffect(() => {
  if(reptType){
    validateAndShowFORMErrors(null)
    
    // Initialize catering groups and reset width when reptType is stockMovementVarianceReport
    if(reptType === 'stockMovementVarianceReport') {
      setCateringGroups([{key: 0, label: 'Select', value: '', id: ''}]);
      setCateringGroupWidth('17rem');
    }
  }
}, [reptType])

useEffect(() => {
  if(modalFormData.reportType){
    validateAndShowFORMErrors({target: {name: 'reportType', value: modalFormData.reportType}})
    
    // Reset catering groups and width when switching away from stockMovementVarianceReport
    if(modalFormData.reportType !== 'stockMovementVarianceReport') {
      isLoadingCateringGroupsRef.current = false;
      setIsCateringGroupsLoading(false);
      setCateringGroups([{key: 0, label: 'Select', value: '', id: ''}]);
      setCateringGroupWidth('17rem');
    }
  }
}, [modalFormData.reportType])

    useEffect( () => {
        if ( reportTypes.length && routes.length > 0 && editFormFields.length > 0&&!reptType ) {
            updateEditFormInputs();
        }
    }, [reportTypes, routes, cateringGroups, modalFormData ]);

    useEffect(() => {
        // Update catering group loading state and width in editFormFields
        const cateringGroupField = editFormFields.find(f => f.attribute === 'cateringGroup');
        const transDateField = editFormFields.find(f => f.attribute === 'transDate');
        const reportTypeField = editFormFields.find(f => f.attribute === 'reportType');
        const endDateField = editFormFields.find(f => f.attribute === 'endDate');
        
        if (cateringGroupField || transDateField || reportTypeField || endDateField) {
            const updatedFields = editFormFields.map(field => {
                if (field.attribute === 'reportType' && (modalFormData.reportType === 'stockMovementVarianceReport' || reptType === 'stockMovementVarianceReport')) {
                    return {
                        ...field,
                        style: { width: cateringGroupWidth }
                    };
                }
                if (field.attribute === 'cateringGroup') {
                    return {
                        ...field,
                        options: cateringGroups,
                        optionsLoading: isCateringGroupsLoading,
                        width: cateringGroupWidth
                    };
                }
                if (field.attribute === 'transDate' && (modalFormData.reportType === 'stockMovementVarianceReport' || reptType === 'stockMovementVarianceReport')) {
                    return {
                        ...field,
                        width: cateringGroupWidth
                    };
                }
                if (field.attribute === 'endDate') {
                    return {
                        ...field,
                        maxDate: modalFormData.startDate ? getEndDateMaxLimit(modalFormData.startDate) : null
                    };
                }
                return field;
            });
            setEditFormFields(updatedFields);
        }
    }, [isCateringGroupsLoading, cateringGroups, cateringGroupWidth, modalFormData.startDate]);

    useEffect(() => {
        // Update download button width based on report type and cateringGroupWidth
        if (modalFormData.reportType === 'stockMovementVarianceReport' || reptType === 'stockMovementVarianceReport') {
            setModalCustomButtons([
                { 
                    label: 'Download', 
                    attribute: 'button', 
                    type: 'button', 
                    disabled: false, 
                    className: 'submit-button-rep1 mt-4',
                    action: 'onSubmit',
                    style: { width: cateringGroupWidth }
                }
            ]);
        } else {
            setModalCustomButtons([
                { 
                    label: 'Download', 
                    attribute: 'button', 
                    type: 'button', 
                    disabled: false, 
                    className: 'submit-button-rep1 mt-4',
                    action: 'onSubmit',
                    style: {}
                }
            ]);
        }
    }, [modalFormData.reportType, reptType, cateringGroupWidth]);

    const showFieldValidation = () => {
        if ( editFormFields.length > 0) {
            editFormFields.forEach( _ => {
                const foundInpElement = document.getElementById(_.id);

                if (foundInpElement) {

                if (_.required === true) {
                    validateEmptyError( foundInpElement);
                }

                }

            });

        }
    };

    const loadReportTypes = async () => {
        //, { signal: newAbortSignal('reportTypesAPI', 5000) }
        try {
          const resp = await DFPAPIEndpoint.get('reports/reportTypes');
        if (resp.result.length > 0) {
            const options = [{key: 0, label: 'Select', value: '', id: ''}];
            resp.result.map( (fieldValue, index) => {
              options.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.id}`, id: `${fieldValue.id}`});

              return fieldValue;
            });

            options.push({key: options.length+1, label: 'Stock Movement Variance Report', value: 'stockMovementVarianceReport', id: 'stockMovementVarianceReport'});

            setReportTypes(options);
            // updateEditFormInputs(options, null);
        }
        } catch (error) {

        }

    }

    const popupForm_loadRoutes = async () => {
        if ( props.sectorList.length > 0) {
            const options = [{key: 0, label: 'Select', value: '', id: ''}];

            props.sectorList.filter( (fieldValue, index) => {
                options.push({key: index+1, label: `${fieldValue.label}`, value: `${fieldValue.value}`, id: `${fieldValue.id}`});

                return fieldValue;
            });

            setRoutes(options);
            // updateEditFormInputs(null, options);
        }
    }

    const loadCateringGroupsByDate = async (date) => {
        if (!date) return;
        
        // Prevent multiple simultaneous calls
        if (isLoadingCateringGroupsRef.current) {
            return;
        }
        
        isLoadingCateringGroupsRef.current = true;
        setIsCateringGroupsLoading(true);
        try {
            const requestPayload = {
                date: moment(date).format('YYYY-MM-DD')
            };

            const response = await APIEndpoint.post('operations/rotations/find', requestPayload);

            const options = [{key: 0, label: 'Select', value: '', id: ''}];
            
            if (response.rotations && response.rotations.length > 0) {
                response.rotations.forEach((ele, index) => {
                    const dte = moment(ele.legs[0]?.std).format('DD-MM-YYYY hh:mm A');
                    options.push({
                        key: index + 1,
                        label: `${ele.tailNumber}/${ele.flightPath}/${dte}`,
                        value: ele.id,
                        id: ele.id
                    });
                });
            }

            setCateringGroups(options);
        } catch (error) {
            console.error('Error loading catering groups:', error);
            setCateringGroups([{key: 0, label: 'Select', value: '', id: ''}]);
        } finally {
            isLoadingCateringGroupsRef.current = false;
            setIsCateringGroupsLoading(false);
        }
    }


    const setUpInitialFormFields = () => {
      let fields = allFormInputsFin
      .filter(field => (field.name === 'reportType' || field.name === 'startDate' || field.name === 'endDate' || field.name === 'selectRoute'))

        setEditFormFields( fields );

    };

    const updateEditFormInputs = (reportTypes2=null, routesArr2=null) => {

      if(!reptType){
                const updatedEditFields = editFormFields.filter( (field) => {

            if (reportTypes.length && field.attribute === 'reportType') {
                field.disabled = reptType?true:false;
                field.options = reportTypes;
                if(!props.reportSel){
                  field.value=modalFormData.reportType;
                }
                // Apply width for stockMovementVarianceReport
                // For 'select' type, use style object instead of width property
                if (modalFormData.reportType === 'stockMovementVarianceReport' || reptType === 'stockMovementVarianceReport') {
                  field.style = { width: cateringGroupWidth };
                }
                // field.getOptions = () => {
                //     return reportTypes;
                // }
                setModalFormStatusObj({ text: '' });
            }
            else if (routes && field.attribute === 'selectRoute' ) {
                field.disabled = false;
                field.options = routes;
                // field.getOptions = () => {
                //     return routes;
                // }
                setModalFormStatusObj({ text: '' });
            }
            else if (cateringGroups && field.attribute === 'cateringGroup' ) {
                field.disabled = false;
                field.options = cateringGroups;
                field.optionsLoading = isCateringGroupsLoading;
                field.width = cateringGroupWidth;
                setModalFormStatusObj({ text: '' });
            }
            else if (field.attribute === 'endDate') {
                field.maxDate = modalFormData.startDate ? getEndDateMaxLimit(modalFormData.startDate) : null;
            }

            return field;
        });

        setEditFormFields( updatedEditFields );
      }

    };
    const onSectorChange=(e)=>{

      let newUpdates = modalFormData ? { ...modalFormData } : {}
      newUpdates['storeId'] = e.selectRoute ?? '';
      setModalFormData(newUpdates);
      validateAndShowFORMErrors(e);
    }
    const onModalFormInputChange = (e, newFormData) => {
        const { name, value } = e.target;

        let newUpdates = modalFormData ? { ...modalFormData } : {}
        newUpdates[name] = value ?? '';

        setModalFormData( { ...newFormData } );

        // Load catering groups when date changes for stockMovementVarianceReport
        if (name === 'transDate' && (newFormData.reportType === 'stockMovementVarianceReport' || reptType === 'stockMovementVarianceReport')) {
            if (value) {
                loadCateringGroupsByDate(value);
                // Reset width when date changes (catering group will be cleared)
                setCateringGroupWidth('17rem');
            } else {
                isLoadingCateringGroupsRef.current = false;
                setIsCateringGroupsLoading(false);
                setCateringGroups([{key: 0, label: 'Select', value: '', id: ''}]);
                setCateringGroupWidth('17rem');
            }
        }

        validateAndShowFORMErrors(e);
    }

    const validateAndShowFORMErrors = (e) => {

      const { name = '', value = '', required = false } = e?.target || {};
 
        /** Step 1 */

        const updtReportTypeFields = () => {
          let updatedEditFields = [];
          const selectedReportType = value || reptType || modalFormData.reportType;
          switch ( selectedReportType ) {
            case '':

              updatedEditFields = [ ...allFormInputsFin.filter( _ =>
                ( _.name === 'reportType' || _.name === 'startDate' || _.name === 'endDate' || _.name === 'selectRoute' )
              ) ].map(field => {
                // Remove custom width from reportType for non-stockMovementVarianceReport
                if (field.attribute === 'reportType') {
                  const { style, ...rest } = field;
                  return rest;
                }
                // Remove custom width from any field
                if (field.width) {
                  const { width, ...rest } = field;
                  return rest;
                }
                return field;
              });

            break;
            case 'salesSummary':

              updatedEditFields = [ ...allFormInputsFin.filter( _ =>
                ( _.name === 'reportType' || _.name === 'filterByTransactionDate' || _.name === 'startDate' || _.name === 'endDate' || _.name === 'selectRoute' )
              ) ].map(field => {
                // Remove custom width from reportType for non-stockMovementVarianceReport
                if (field.attribute === 'reportType') {
                  const { style, ...rest } = field;
                  return rest;
                }
                // Remove custom width from any field
                if (field.width) {
                  const { width, ...rest } = field;
                  return rest;
                }
                return field;
              });

            break;
            case 'inventoryTransactionAggregate':

              updatedEditFields = [ ...allFormInputsFin.filter( _ =>
                ( _.name === 'reportType' || _.name === 'transDate' || _.name === 'selectRoute' )
              ) ].map(field => {
                // Remove custom width from reportType for non-stockMovementVarianceReport
                if (field.attribute === 'reportType') {
                  const { style, ...rest } = field;
                  return rest;
                }
                // Remove custom width from transDate for non-stockMovementVarianceReport
                if (field.attribute === 'transDate') {
                  const { width, ...rest } = field;
                  return rest;
                }
                return field;
              });

            break;
            case 'itemwiseAggregate':
              updatedEditFields = [ ...allFormInputsFin.filter( _ =>
                ( _.name === 'reportType' || _.name === 'startDate' || _.name === 'endDate' || _.name === 'selectRoute' )
              ) ].map(field => {
                // Remove custom width from reportType for non-stockMovementVarianceReport
                if (field.attribute === 'reportType') {
                  const { style, ...rest } = field;
                  return rest;
                }
                // Remove custom width from any field
                if (field.width) {
                  const { width, ...rest } = field;
                  return rest;
                }
                return field;
              });

            break;
            case 'invoiceReport':
              updatedEditFields = [ ...allFormInputsFin.filter( _ =>
                ( _.name === 'reportType' || _.name === 'startDate' || _.name === 'endDate' || _.name === 'selectRoute' )
              ) ].map(field => {
                // Remove custom width from reportType for non-stockMovementVarianceReport
                if (field.attribute === 'reportType') {
                  const { style, ...rest } = field;
                  return rest;
                }
                // Remove custom width from any field
                if (field.width) {
                  const { width, ...rest } = field;
                  return rest;
                }
                return field;
              });
            break;
            case 'invoiceItemWiseReport':
              updatedEditFields = [ ...allFormInputsFin.filter( _ =>
                ( _.name === 'reportType' || _.name === 'startDate' || _.name === 'endDate' || _.name === 'selectRoute' )
              ) ].map(field => {
                // Remove custom width from reportType for non-stockMovementVarianceReport
                if (field.attribute === 'reportType') {
                  const { style, ...rest } = field;
                  return rest;
                }
                // Remove custom width from any field
                if (field.width) {
                  const { width, ...rest } = field;
                  return rest;
                }
                return field;
              });
            break;
            case 'sectorSalesReport':
              updatedEditFields = [ ...allFormInputsFin.filter( _ =>
                ( _.name === 'reportType' || _.name === 'startDate' || _.name === 'endDate' || _.name === 'selectRoute' )
              ) ].map(field => {
                // Remove custom width from reportType for non-stockMovementVarianceReport
                if (field.attribute === 'reportType') {
                  const { style, ...rest } = field;
                  return rest;
                }
                // Remove custom width from any field
                if (field.width) {
                  const { width, ...rest } = field;
                  return rest;
                }
                return field;
              });
            break;
            case 'stockMovementVarianceReport':
              updatedEditFields = [ ...allFormInputsFin.filter( _ =>
                ( _.name === 'reportType' || _.name === 'transDate' || _.name === 'cateringGroup' )
              ) ].map(field => {
                // Apply width to all fields for stockMovementVarianceReport
                if (field.attribute === 'reportType') {
                  return { ...field, style: { width: cateringGroupWidth } };
                }
                if (field.attribute === 'transDate' || field.attribute === 'cateringGroup') {
                  return { ...field, width: cateringGroupWidth };
                }
                return field;
              });
            break;
            default:
            break;
          }

          if (updatedEditFields.length > 0) {
            setEditFormFields( updatedEditFields );

            // updateEditFormInputs(null, null);
          }

        }

        if (name === 'reportType' || reptType || modalFormData.reportType) {

            updtReportTypeFields();
        }

        if ( required === true ) {
            validateEmptyError( e.target );
        }

    }

    const validateEmptyError = ( targetElt ) => {
        const { name, id } = targetElt;
        const inpKey = id ?? name;

        const inpElt = document.getElementById(inpKey);

        const childValidateMsgDiv = document.createElement('div');
        childValidateMsgDiv.id = inpKey +'_childValidateMsgDiv';
        childValidateMsgDiv.classList = ['validationMsgDiv'];

        const foundChildDiv = document.getElementById(inpKey +'_childValidateMsgDiv');


        if (foundChildDiv) {
          try {
            if (targetElt.parentElement) {
              targetElt.parentElement.removeChild(foundChildDiv);
            }
            else {
              // Fix: Datepicker input not returning event object
              foundChildDiv.remove();
            }
          }
          catch(e) {
            console.error('Log: Error occured while removing existing error message:', e.message);
          }
        }


        // if ( value === '' ) {
        //   childValidateMsgDiv.classList.add('error');
        //   childValidateMsgDiv.innerHTML = '* Required';
        // }

        if(targetElt.parentElement) {
          targetElt.parentElement.appendChild(childValidateMsgDiv);
        }
        else {
          // Fix: Datepicker input not returning event object
          inpElt.appendChild(childValidateMsgDiv);
        }
    };

    const updateEditFormValues = async (e, updatedFormObj) => {

        // ReactDOM.flushSync( () => {
        //     if (e) {
        //         const selectedReportType = reportTypes.find( item => item.value === e);
        //         console.log('selectedReportType:', selectedReportType);

        //         /** Set to respective fields */
        //         // const updatedEditFields = editFormFields.filter( (field) => {

        //         //     if (selectedReportType ) {
        //         //         if ( field.attribute === 'reportType' ) {
        //         //             field.value = selectedReportType.label;
        //         //         }
        //         //     }

        //         //     return field;

        //         // });

        //         // setEditFormFields( _prev => {
        //         //     return [ ...updatedEditFields ] ;
        //         // });
        //     }
        // })
    };




    const validateFormInputs = (body, frm='') => {
        setModalFormStatusObj({ text: '' });

        if (!body) {
            setModalFormStatusObj({ error: 'Please select all the necessary fields!' });
            return false;
        }

        if ( frm ==='downloadReportPopup' ) {
            if (!body.reportType && !reptType) {
                setModalFormStatusObj({ error: 'Please select report type.' });
                return false;
            }
            else {

              switch ( body.reportType ||reptType) {
                case 'salesSummary':

                  if ( !body.startDate || !body.endDate ) {
                    setModalFormStatusObj({ error: 'Please select all required fields(*).' });
                    return false;
                  }

                break;
                case 'inventoryTransactionAggregate':

                  if ( !body.transDate ) {
                    setModalFormStatusObj({ error: 'Please select all required fields(*).' });
                    return false;
                  }

                  body.startDate = body.transDate;
                  body.endDate = body.transDate;
                  delete body.transDate;

                break;
                case 'itemwiseAggregate':
                  if ( !body.startDate || !body.endDate ) {
                    setModalFormStatusObj({ error: 'Please select all required fields(*).' });
                    return false;
                  }

                break;
                case 'invoiceReport':
                  if ( !body.startDate || !body.endDate ) {
                    setModalFormStatusObj({ error: 'Please select all required fields(*).', });
                    return false;
                  }
                break;
                case 'invoiceItemWiseReport':
                  if ( !body.startDate || !body.endDate ) {
                    setModalFormStatusObj({ error: 'Please select all required fields(*).' });
                    return false;
                  }
                break;
                case 'sectorSalesReport':
                  if ( !body.startDate || !body.endDate ) {
                    setModalFormStatusObj({ error: 'Please select all required fields(*).', });
                    return false;
                  }
                break;
                case 'stockMovementVarianceReport':
                  if ( !body.transDate ) {
                    setModalFormStatusObj({ error: 'Please select date.' });
                    return false;
                  }
                  if ( !body.cateringGroup ) {
                    setModalFormStatusObj({ error: 'Please select catering group.' });
                    return false;
                  }
                break;
                default:
                break;
              }

            }

        }
        return true;
    };

    const onSubmit = async (e, updated) => {

        try {


          updateButtonTxtStatus(true, e, 'Processing...', true, {
            className: 'failedCls',
            defaultButtonText: 'Download',
            loadingImage: LoadingIn
        });
            if ( !validateFormInputs(updated, 'downloadReportPopup' ) ) {
                updateButtonTxtStatus(true, e, 'Download', false);
                return false;
            }

            try {
                const reportTypeObj = reportTypes.find( row => (updated.reportType?updated.reportType:reptType) === row.value);
                if ( !reportTypeObj ) {
                    setModalFormStatusObj({ error: 'Invalid report type selected, Please check.'});
                    updateButtonTxtStatus(true, e, 'Download', false);
                    return false;
                }

                const downloadPayload = {
                    reportType: reportTypeObj.id
                };
                if (updated.startDate) {
                  downloadPayload.startDate = formatDateByTimezone(new Date(updated.startDate),true);
                }
                if (updated.endDate) {
                  downloadPayload.endDate = formatDateByTimezone(new Date(updated.endDate),true);
                }
                if ( updated.selectRoute ) {
                  downloadPayload.storeId = updated.selectRoute;
                }
                if (updated.reportType === 'salesSummary') {
                  downloadPayload.filterByTransactionDate = false;
                  if ( updated.filterByTransactionDate === true) {
                    downloadPayload.filterByTransactionDate = true;
                  }
                }

                if ((updated.reportType || reptType) === 'stockMovementVarianceReport') {
                  // Override payload for stockMovementVarianceReport
                  downloadPayload.reportType = 'stockMovementVarianceReport';
                  downloadPayload.date = formatDateByTimezone(new Date(updated.transDate), false);
                  downloadPayload.cateringGroup = {
                    id: updated.cateringGroup,
                    name: cateringGroups.find(cg => cg.value === updated.cateringGroup)?.label || ''
                  };
                  downloadPayload.fileType = 'excel';
                  // Remove fields not needed for this report type
                  delete downloadPayload.startDate;
                  delete downloadPayload.endDate;
                  delete downloadPayload.storeId;
                }

                let header={
                  'Accept':'text/csv'
                }
                
                if ((updated.reportType || reptType) === 'stockMovementVarianceReport') {
                  header = {
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                  };
                }
                  try {

                  const res= await APIEndpoint.post(`sales/reports`,downloadPayload,header);
                  if(res.status==='scheduled'){
                    // For stockMovementVarianceReport, use checkDownloadStatus with callbacks
                    if ((updated.reportType || reptType) === 'stockMovementVarianceReport') {
                      const onDownloadSuccess = () => {
                        updateButtonTxtStatus(true, e, 'Download', false);
                        toast.success("Stock movement variance report downloaded successfully");
                        props.onClose();
                      };
                      
                      const onDownloadFailure = () => {
                        updateButtonTxtStatus(true, e, 'Download', false);
                        toast.error("Failed to download stock movement variance report");
                      };
                      
                      checkDownloadStatus(res.id, onDownloadSuccess, onDownloadFailure, true);
                    } else {
                      // For other reports, reset button on completion
                      const onDownloadSuccess = () => {
                        updateButtonTxtStatus(true, e, 'Download', false);
                      };
                      
                      const onDownloadFailure = () => {
                        updateButtonTxtStatus(true, e, 'Download', false);
                        setTimeout(() => {
                          typeof props.setIsDownloading==='function' && props.setIsDownloading({rept:"Reconciled",stat:"Failed"});
                        }, 5000);
                      };
                      
                      props.checkDownloadStatus(res.id, onDownloadSuccess, onDownloadFailure);
                    }
                  }
                  }
                   catch (error) {
                    updateButtonTxtStatus(true, e, 'Download', false);
                    
                    if ((updated.reportType || reptType) === 'stockMovementVarianceReport') {
                      toast.error("Failed to download stock movement variance report");
                    } else {
                      setTimeout(() => {
                        typeof props.setIsDownloading==='function' &&props.setIsDownloading({rept:"Reconciled",stat:"Failed"});
                      }, 5000);
                    }
                   }

              }
              catch( er ) {
                  console.log('Error while downloading report...', er.message);
                  updateButtonTxtStatus(true, e, 'Download', false);
                  if ((updated.reportType || reptType) === 'stockMovementVarianceReport') {
                    toast.error("Failed to download stock movement variance report");
                  }
              }


        }
        catch(err) {
            setModalFormStatusObj({ error:err.data.msg});
        }
    };

    return (
        <EditModal
            className='salesPageModal'
            title={ modalTitle }
            customModalStyle={ modelStyle }
            onClose={ () => props.onClose() }
            onSubmit={onSubmit}
            modalFormStatusObj={modalFormStatusObj}
            modalCustomButtons={modalCustomButtons}
            fields={ editFormFields.map( (elt) => {
              if(elt.attribute==='reportType' && reptType){
                return {...elt, initialValue: '',disabled:true }
              }
              else if(elt.attribute==='transDate'){
                return {...elt, value:modalFormData.transDate }
              }
              else {
                return {...elt, initialValue: '' }
              }
                })
            }
            showFieldsInColumn={true}

            onChange={ (e, updated) => {
              setModalFormStatusObj({text:""})

                    setUpdatedFormFieldValues(updated);

                    if (e?.target?.name === 'startDate' && updated.startDate) {
                      const maxEndDate = getEndDateMaxLimit(updated.startDate);
                      if (updated.endDate && maxEndDate && new Date(updated.endDate) > maxEndDate) {
                        updated.endDate = null;
                      }
                    }

                    // Handle catering group width calculation for stockMovementVarianceReport
                    if ((updated.reportType === 'stockMovementVarianceReport' || reptType === 'stockMovementVarianceReport')) {
                      if (updated.cateringGroup) {
                        const selectedCG = cateringGroups.find(cg => cg.value === updated.cateringGroup);
                        if (selectedCG?.label) {
                          const newWidth = calculateTextWidth(selectedCG.label);
                          setCateringGroupWidth(`${newWidth + 100}px`);
                        }
                      } else if (updated.hasOwnProperty('cateringGroup') && !updated.cateringGroup) {
                        // Catering group cleared
                        setCateringGroupWidth('17rem');
                      }
                    }

                    if (typeof e === 'string') { // Search select
                        updateEditFormValues(e, updated);
                    }
                    if(!e && updated){
                      onSectorChange(updated)
                    }
                    else {
                        onModalFormInputChange(e, updated);
                    }

                }
            }
        />
    )
};